type Course = 'standard' | 'aligned'

const state: { course: Course } = {
  course: 'standard',
}

const getters = {
  course: (state: any) => state.course,
}

const mutations = {
  setCourse(state: any, course: Course) {
    state.course = course
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
